var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_vm._l((_vm.breadcrumbs),function(crumb){return [_c('li',{key:crumb.name},[_c('router-link',{attrs:{"to":crumb.path}},[_vm._v("\n                    "+_vm._s(crumb.name)+"\n                ")])],1)]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fbf7ed9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseBreadCrumb.vue
// module id = null
// module chunks = 